export function formatDate(duration: string) {
  if (!duration) return `00:00`
  const hrs = duration.split(":")[0]
  const mins = duration.split(":")[1]
  const seconds = duration.split(":")[2]
  return `${
    hrs != "00"
      ? parseInt(hrs).toString() + ":" + mins + ":"
      : parseInt(mins).toString() + ":"
  }${seconds.split(".")[0]}`
}
